<template>
  <div class="risk-warn">
    <div class="risk-warn-container">
      <div v-if="editableTabs.length>0" class="border"></div>
      <div v-if="editableTabs.length>0" class="right-border"></div>
      <el-button
        type="text"
        class="btn-border-text-blue add-type"
        @click="addType"
        >新增分类</el-button
      >
      <el-tabs
        v-if="editableTabs.length>0"
        v-model="editableTabsValue"
        type="card"
        closable
        @tab-remove="removeTab"
        @tab-click="tabClick">
        <el-tab-pane
          v-for="item in editableTabs"
          :key="item.name"
          :label="item.title"
          :name="item.name"
        >
          <span slot="label">
            <span class="span-box">
              <span>{{ item.title }}</span>
              <i :class="editableTabsValue == item.name?'el-icon-edit':'el-icon-edit tab-edit'" @click="rename(item)"></i>
            </span>
          </span>
          <div class="right-container">
            <div class="top-container">
              <div class="title">{{typeName}}</div>
              <div class="search">
                <el-button
                  type="text"
                  class="btn-blue add"
                  @click="openAddRiskContent"
                  >添加内容</el-button
                >
              </div>
            </div>
            <div class="table" v-if="tableData.length > 0">
              <el-table :data="tableData" style="width: 100%">
                <el-table-column label="风险内容" prop="riskContent" min-width="400">
                  <template slot-scope="scope">
                    <el-tooltip v-if="!isShowTooltip" class="item" effect="dark" placement="top-start">
                      <div slot="content">
                        <span v-for="(item, index) in scope.row.riskContent" :key="index">
                          <span style="display:inline-block;">
                            {{item}}
                          </span>
                          <br v-if="(index+1)%20==0"/>
                        </span>
                      </div>
                      <div :class="scope.row.status == 'HIGH' ? 'high-risk': scope.row.status =='MIDDLE'?'medium-risk':'low-risk'">
                        <span :ref="`refRiskTooltip${scope.$index}`" @mouseover="onMouseOver(`refRiskTooltip${scope.$index}`)">{{scope.row.riskContent}}</span>
                      </div>
                    </el-tooltip>
                    <div v-else :class="scope.row.status == 'HIGH' ? 'high-risk': scope.row.status =='MIDDLE'?'medium-risk':'low-risk'">
                      <span :ref="`refRiskTooltip${scope.$index}`" @mouseover="onMouseOver(`refRiskTooltip${scope.$index}`)">{{scope.row.riskContent}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="评分标准" prop="scoringCriteria" min-width="200">
                </el-table-column>
                <el-table-column label="扣分规制" prop="deductionRegulation" min-width="200"></el-table-column>
                <el-table-column label="操作" width="150">
                  <template slot-scope="scope">
                    <img class="mod" src="../../../../assets/risk/mod.png" @click="modRiskContent(scope.row, scope.$index)">
                    <img class="del" src="../../../../assets/risk/del.png" @click="remove(scope.row.id)">
                  </template>
                </el-table-column>
              </el-table>
              <div class="pagination-tpl-container">
                <pagination-tpl
                  :total="totalNum"
                  :currentPage="currentPage"
                  @queryChange="onQueryChange"
                ></pagination-tpl>
              </div>
            </div>
            <div class="nothing" v-if="tableData.length == 0">
              <div>
                <div>
                  <img src="../../../../assets/nothing.png">
                </div>
                <p>暂无数据</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 新增分类和重命名 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
      >
        <el-form-item label="分类名称" prop="typeName">
          <el-input class="gray white" v-model="form.typeName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增内容，编辑内容 -->
    <el-drawer
      :visible.sync="drawer"
      :size="400"
      :modal="false"
      :with-header="false"
      :wrapperClosable="false"
    >
      <div class="drawer-title">
        <i class="el-icon-close" @click="closeDrawer"></i>
        <div>
          <el-button type="text" class="btn-gray" @click="closeDrawer"
            >取消</el-button
          >
          <el-button
            type="text"
            class="btn-blue"
            @click="submitForm('ruleForm')"
            >保存</el-button
          >
        </div>
      </div>
      <div class="sub-title">
        {{ isModContent ? "编辑内容" : "添加内容" }}
      </div>
      <el-form
        :model="ruleForm"
        :rules="ruleFormRules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item label="风险内容" prop="textarea">
          <el-input
            type="textarea"
            placeholder="请输入详细内容"
            v-model="ruleForm.textarea"
            :autosize="{ minRows: 5, maxRows: 5 }"
            resize="none"
            maxlength="100"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="评分标准" prop="scoringCriteria">
          <el-input
            type="textarea"
            placeholder="请输入详细内容"
            v-model="ruleForm.scoringCriteria"
            :autosize="{ minRows: 5, maxRows: 5 }"
            resize="none"
            maxlength="100"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <div class="deduction-regulation">
          <div class="deduction-regulation-title">
            <label>扣分规制</label>
            <div class="add-deduction-regulation" @click="addDeductionRegulation">
              <i class="el-icon-plus"></i>
              添加规制
            </div>
          </div>
          <div
            class="deduction-regulation-nums"
          >
          <div
            v-for="(item,index) in ruleForm.deductionRegulationList"
            :key="index"
            class="deduction-regulation-input"
          >
            <i v-if="activeIndex == index" class="el-icon-circle-close" @click="delDeductionRegulation(index)"></i>
            <el-input
              class="gray white"
              v-model="item.nums"
              @input="
                inputAmount(
                  item.nums,
                  item,
                )"
              @focus="focusInput(index)"
            >
            </el-input>
          </div>
          </div>
        </div>
        <el-form-item label="风险等级" prop="riskLevel">
          <el-select
            v-model="ruleForm.riskLevel"
            placeholder="请选择"
            class="gray white"
          >
            <el-option
              v-for="item in riskLevelList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
              <span class="risk-level">
                <span :class="item.id == 'HIGH' ? 'high-risk-sign': item.id =='MIDDLE'?'medium-risk-sign':'low-risk-sign'"></span>
                {{ item.name }}
              </span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import PaginationTpl from "@/components/PaginationTpl.vue";
import { inputAllTwoDecimal, handleAmount } from "@/common/js/utils.js";
import { statusMixins } from '@/common/mixins/status/status.js'
import Risk from "@/models/risk.js";
export default {
  mixins: [statusMixins],
  components: {
    PaginationTpl
  },

  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      tableData: [],
      // 分类id
      typeId: '',
      typeName: '',
      dialogVisible: false,
      dialogTitle: '新增风险',
      // 是否是新增分类; 1.是新增风险 2.修改分类名称
      isAddType: 1,
      form: {
        typeName: '',
      },
      rules: {
        typeName: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      riskContentIndex: '',
      /* 是否开启抽屉 */
      drawer: false,
      /* 是否编辑风险内容; 1.是; 0.否*/
      isModContent: "",
      ruleForm: {
        detailsId: '',
        textarea: "",
        scoringCriteria: "",
        riskLevel: '',
        deductionRegulationList: [
          {nums:''},
        ]
      },
      ruleFormRules: {
      },
      riskLevelList: [
        {id:'LOW', name: '低风险'},
        {id:'MIDDLE', name: '中风险'},
        {id:'HIGH', name: '高风险'},
      ],
      editableTabsValue: "",
      editableTabs: [],
      isShowTooltip: true,
      activeIndex: null
    }
  },

  created() {
    config()
    this.initRiskTypeList()
  },

  methods: {
    onMouseOver(str) {
      const tag = this.$refs[str]
      // 获取父级元素的可视高度
      const parentHeight = tag[0].parentNode.offsetHeight
      // 获取元素的可视高度
      const contentHieght = tag[0].offsetHeight
      this.isShowTooltip = contentHieght <= parentHeight
    },

    /* 获取风险分类 */
    initRiskTypeList() {
      Risk.getRiskTypeLsit().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.title = i.name
            obj.name = String(i.id)
            arr.push(obj)
          })
          this.editableTabs = arr
          if (arr.length> 0) {
            this.editableTabsValue = arr[0].name
            this.typeId = arr[0].id
            this.typeName = arr[0].title
            this.initRiskContentList()
          }
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取内容集合 */
    initRiskContentList() {
      let pageNo = this.currentPage
      let riskId = this.typeId
      let data = {
        pageNo,
        riskId
      }
      Risk.getRiskDetailsList(data).then(res => {
        if (res.success) {
          let arr = []
          this.totalNum = res.result.totalNum
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.riskId = i.riskId
            obj.status = i.level
            obj.riskContent = i.content
            obj.scoringCriteria = i.standard
            obj.deductionRegulation = ''
            obj.pointRuleList = []
            i.pointRuleList.map(v => {
              let point = handleAmount(v,2).toString()
              obj.deductionRegulation += `${point}；`
              let pointRuleObj = {}
              pointRuleObj.nums = point
              obj.pointRuleList.push(pointRuleObj)
            })
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },
    
    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initRiskContentList();
    },

    /* 删除分类 */
    delRiskType() {
      let data = {
        id: this.typeId
      }
      Risk.postDelRiskType(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          this.initRiskTypeList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 保存分类 */
    saveRiskType(isAddType) {
      let data = {
        id: isAddType == 1 ? '':this.typeId,
        name: this.form.typeName
      }
      Risk.postSaveRiskType(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '保存成功'
          });
          this.initRiskTypeList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 删除内容 */
    remove(id) {
      this.$confirm("内容删除后不可恢复，是否继续？", "确认删除内容", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let data = {
          id
        }
        Risk.postDelRiskDetails(data).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.initRiskContentList()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      });
    },

    tabClick(tab) {
      let obj = this.editableTabs[tab.index];
      this.typeId = obj.id
      this.typeName = obj.title
      this.initRiskContentList()
    },

    openAddRiskContent() {
      if (!this.typeId) return this.$message.error('请先选择分类')
      this.ruleForm.detailsId = ''
      this.isModContent = 0
      this.drawer = true
    },

    modRiskContent(row, index) {
      console.log(row);
      this.riskContentIndex = index
      this.ruleForm.detailsId = row.id;
      this.ruleForm.textarea = row.riskContent;
      this.ruleForm.riskLevel = row.status;
      this.ruleForm.scoringCriteria = row.scoringCriteria;
      this.ruleForm.deductionRegulationList = row.pointRuleList
      this.isModContent = 1
      this.drawer = true
    },
    
    closeDrawer() {
      this.ruleForm.detailsId = "";
      this.ruleForm.textarea = "";
      this.ruleForm.riskLevel = "";
      this.ruleForm.scoringCriteria = "";
      this.ruleForm.deductionRegulationList = [{nums: ''}]
      this.activeIndex = null
      this.drawer = false;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let deductionRegulationList = this.ruleForm.deductionRegulationList
          let isNull = deductionRegulationList.every(item => item.nums != '')
          let isRepeat = this.isRepeat(deductionRegulationList)
          if (!isNull) {
            return this.$message.error('请设置扣分规则')
          }
          if (!isRepeat) {
            return this.$message.error('扣分规则不可重复')
          }
          let pointRuleList = []
          deductionRegulationList.map(i => {
            pointRuleList.push(handleAmount(i.nums,1))
          })
          let id = this.ruleForm.detailsId
          let riskId = this.typeId
          let content = this.ruleForm.textarea
          let standard = this.ruleForm.scoringCriteria
          let level = this.ruleForm.riskLevel
          let data = {
            id,
            riskId,
            content,
            standard,
            level,
            pointRuleList
          }
          Risk.postSaveRiskDetails(data).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "保存成功",
              });
              this.closeDrawer();
              this.initRiskContentList()
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    isRepeat(arr) {
      const newArr = arr.map(item => item.nums.toString())
      const arrSet = new Set(newArr)
      return (newArr.length === arrSet.size)
    },

    rename(row) {
      this.typeId = row.id
      this.form.typeName = row.title
      this.isAddType = 2
      this.dialogTitle = '修改风险名称'
      this.dialogVisible = true
    },

    /* 开启新增分类 */
    addType() {
      this.clear()
      this.isAddType = 1
      this.dialogTitle = '新增风险'
      this.dialogVisible = true
    },

    handleClose() {
      this.dialogVisible = false
    },

    clear() {
      this.form.typeName = ''
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveRiskType(this.isAddType)
          this.handleClose()
          this.clear()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let row = tabs.filter(tab => tab.name == targetName);
      this.typeId = row.length> 0?row[0].id:""
      if (this.tableData.length > 0) {
        this.$alert('请先删除所有子规制再进行删除风险名称操作', '确认删除风险', {
          confirmButtonText: '好的',
          confirmButtonClass: 'btn-gray'
        })
      } else {
        this.$confirm("分类删除后不可恢复，是否继续？", "确认删除分类", {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          confirmButtonClass: 'btn-red',
          cancelButtonClass: 'btn-gray'
        }).then(() => {
          this.delRiskType()
        });
      }
    },
    
    /* 限制自定义金额为两位小数 */
    inputAmount(v, row) {
      row.nums = inputAllTwoDecimal(v);
    },

    addDeductionRegulation() {
      let obj = {nums: ''}
      this.ruleForm.deductionRegulationList.push(obj)
    },

    focusInput(index) {
      this.activeIndex = index
    },

    delDeductionRegulation(index) {
      this.ruleForm.deductionRegulationList.splice(index,1)
    }
  }
}
</script>

<style lang='scss'>
.risk-warn {
  flex: 1;
  background: $bg-white;
  .risk-warn-container {
    height: 100%;
    display: flex;
    justify-content: center;
    position: relative;
  }
  .border,
  .right-border {
    width: 20px;
    height: 1px;
    background: $bg-tabs;
    position: absolute;
    top: 48px;
  }
  .border {
    left: 0px;
  }
  .right-border {
    width: 124px;
    right: 0px;
  }
  .el-tabs {
    width: 100%;
    margin: 8px 20px 0px 20px;
    .el-icon-edit {
      margin-left: 10px;
    }
    .tab-edit {
      display: none;
    }
    .el-tabs__item {
      &:hover {
        .tab-edit {
          display: inline-block;
        }
      }
    }
  }
  .el-tabs__header {
    width: calc(100vw - 379px);
  }
  .el-tabs__content {
    min-height: 753px;
    max-height: 100%;
  }
  .add-type {
    position: absolute;
    top: 10px;
    right: 20px;
  }
  .right-container {
    flex: 1;
    .top-container {
      @include flex-between;
      margin-bottom: 20px;
      .title {
        padding-left: 10px;
        font-size: $fs-medium-s;
        color: $color-BlackGrey;
        border-left: 4px solid $color-DeepReddishBlue;
      }
      .search {
        display: flex;
        .add {
          margin-left: 12px;
          padding: 0px 10px;
        }
      }
    }
    .nothing {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      img {
        width: 157px;
        height: 157px;
      }
      p {
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-LightGrey;
        margin-top: 24px;
      }
    }
    .high-risk {
      @include border-left(3px, 30px, $high-risk, -16px, 50%)
    }
    .medium-risk {
      @include border-left(3px, 30px, $medium-risk, -16px, 50%)
    }
    .low-risk {
      @include border-left(3px, 30px, $low-risk, -16px, 50%)
    }
    .release {
      width: 16px;
      height: 15px;
      cursor: pointer;
    }
    .mod {
      width: 15px;
      height: 16px;
      margin: 0px 19px;
      cursor: pointer;
    }
    .del {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
  .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
    height: auto;
    line-height: 22px;
    @include two-wrap-ellipsis();
  }
  .sub-title {
    text-align: left;
    font-size: $fs-medium-s;
    font-weight: 400;
    margin-bottom: 25px;
    color: $color-Step;
  }
  .el-drawer__wrapper {
    top: 119px !important;
  }
  .el-dropdown-link {
    @include extend-click;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after {
    content: "*";
    color: $bg-Required;
    margin-left: 4px;
  }
  .el-dialog__header,
  .el-dialog__footer {
    border: none;
  }
  .el-dialog__footer {
    @include flex-end;
  }
  .deduction-regulation {
    .deduction-regulation-title {
      @include flex-between;
      font-size: $fs-small-l;
      color: #606266;
      line-height: 40px;
      box-sizing: border-box;
      .add-deduction-regulation {
        font-size: $fs-small-l;
        color: $color-ReddishBlue;
        cursor: pointer;
      }
    }
    .deduction-regulation-nums {
      @include flex-start;
      flex-wrap: wrap;
      .deduction-regulation-input {
        width: 27.3%;
        margin-right: 30px;
        margin-bottom: 10px;
        position: relative;
        .el-icon-circle-close {
          position: absolute;
          top: -8px;
          right: -8px;
          z-index: 2;
          cursor: pointer;
          background: $bg-white;
          color: $bg-DeepReddishBlue;
        }
      }
      .deduction-regulation-input:nth-child(3n) {
        margin-right: 0px;
      }
    }
  }
}
.mod {
  color: $color-grey;
  font-size: $fs-small-l;
}
.delete {
  color: $color-Crimson;
  font-size: $fs-small-l;
}
.risk-level {
  @include flex-start;
}
.high-risk-sign,
.medium-risk-sign,
.low-risk-sign {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 10px;
}
.high-risk-sign {
  background: $high-risk;
}
.medium-risk-sign {
  background: $medium-risk;
}
.low-risk-sign {
  background: $low-risk;
}
</style>
